import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';       // your main component

// 👇 this part is what I meant — don’t edit or delete it
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
